module.exports = __webpack_public_path__ + "img/logo-app.cd4fc3cf.png";